import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { Box, Typography, Button, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { withRouter, useHistory } from 'react-router-dom';


const useStyle = makeStyles((theme) => ({
  headline: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    zIndex: 1
  },
  headlineLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(1)
  }
}));

function HeadlinePage({
  title = '',
  buttonLabel = '',
  handleOnClick=null,
  goBack=null
}) {
  const [t] = useTranslation();
  const classes = useStyle();
  const history = useHistory();

  return (
    <Box className={classes.headline} component="div">
      <Box className={classes.headlineLeft}>
        { (goBack && typeof goBack === "function") ?
          (
            <IconButton aria-label="back" color='primary' onClick={goBack}>
              <ArrowBackIcon />
            </IconButton>
          ): typeof goBack === "string" && (
            <IconButton aria-label="back" color='primary' onClick={() => history.push(goBack)}>
              <ArrowBackIcon />
            </IconButton>
          )
        }
        <Typography variant="h6" id="headlinePage">
          {t(title)}
        </Typography>
      </Box>
      { (buttonLabel && handleOnClick) &&
        <Button onClick={handleOnClick} variant="outlined">
          {t(buttonLabel)}
        </Button>
      }
    </Box>
  );
}

export default withRouter(HeadlinePage)
